module.exports = __webpack_public_path__ + "assets/img/coin-top100-bj.d621bd45.png";